export function getPublishedPosts(posts) {
  return posts.filter((post) => post.status === 'published');
}
